import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { CREATE_GARAGE, UPDATE_GARAGE } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_GARAGE } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/garages-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState({})

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler)
          : <Query
          query={GET_GARAGE}
          variables={{ id: props.match.params.id }}
          fetchPolicy='cache-and-network'
        >{({
          data, error, loading,
        }) => {
          if (loading && _.isEmpty(data)) return <Loading center='true' />
          if (error) return <P>เกิดข้อผิดพลาด</P>
          onChangeHandler = (id, value) => {
            setMutationVariables({
              name: data.GarageInfo.name,
              phoneNumber: data.GarageInfo.phoneNumber,
              ...mutationVariables,
              [id]: value,
            })
          }
          return (
            <Div>
              {
                detailType(props.match.params, onChangeHandler, data.GarageInfo) // argument mode
              }
            </Div>
          )
        }}
        </Query>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_GARAGE : UPDATE_GARAGE}
            >{(doAction, resp) => (
              <ActionBar
                loading={resp.loading}
                disabled={_.isUndefined(mutationVariables.name) || _.isEmpty(mutationVariables.name)
                  || _.isUndefined(mutationVariables.phoneNumber) || _.isEmpty(mutationVariables.phoneNumber)}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={{ ...mutationVariables }}
                props={props}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
